export default "__VITE_ASSET__DwWP0BXJ__"